import { FileClient } from "clients/rest";

export type B100143ExcelRequest = Partial<{
  master: string;
  tankaKbn: string;
  shohinCdFrom: string;
  shohinCdTo: string;
  janCdFrom: string;
  janCdTo: string;
}>;

export const B100143GetExcel = (props: B100143ExcelRequest) => {
  return FileClient.get("b100143/get/excel", {
    params: props,
  });
};
